<script>
import PartnerApi from "@/services/partner-api";

export default {
  name: 'partner',

  data() {
    return {

      partnersCsvFile: null,
      partnersCsvFileImportInProgress: false,
      itemsCsvFailures: null,
      showCartModal:false,
    };
  },


  methods:{

 

    getIcon(status){
      switch(status){
        case 0: return 'disabled.svg';
        case 1: return 'active.svg';
        case 2:return 'stopwatch.svg';
      }
    },

      onPartnersCsvUpload(){
          if(!this.partnersCsvFile) {
              return;
          }

          this.itemsCsvFailures = null;
          this.partnersCsvFileImportInProgress = true;
          const fd = new FormData();
          fd.append('file', this.partnersCsvFile, this.partnersCsvFile.name)
          PartnerApi.importPartnersCsv(fd).then((failures) =>{
                this.partnersCsvFileImportInProgress = false;
                if (failures) {
                    this.itemsCsvFailures = failures;
                }
                this.partnersCsvFile=null
            }
          ).finally(() => {
            this.partnersCsvFileImportInProgress = false;
            this.partnersCsvFile=null;
          })
      },

  }

  
};
</script>


<template>
      <div class=" p-sm-4 p-0 ">

                   <!-- Partner import -->
        <div class="custom-border p-sm-3  mt-5">
                    <div class="text-primary font-size-16 pt-2 pb-2 ">
                        <img  alt="View details"  width="15px"  src="@/assets/icons/csvFile.svg" style="cursor: pointer;" class="mr-1 mb-1"  />
                        <span>{{ $t('zone.text.partnerImport') }}</span>
                    </div>
                        
                    <div class="row pt-sm-2 pb-sm-0" >
                    <div class="col-sm-8 col-12"> 
                        <div class="custom-file custom-input-file-width" style="float:left;"> 
                        <b-form-file
                            v-model="partnersCsvFile"
                            ref="fileUpload"
                            placeholder="Aucun fichier sélectionné"
                            drop-placeholder="Placez le fichier CSV des articles ici"
                            :browse-text="$t('zone.buttons.import')"
                        ></b-form-file>
                        </div>
                    </div>
                        <div class="col-sm-1 col-4 text-sm-left text-right mt-sm-0 mt-3  pr-sm-0 pr-3 ">
                            <p>
                                <a href="/templates/Template-Import-Partner.xlsx" title="Télécharger le modèle du fichier CSV"  class="action-icon text-primary ml-1 ml-sm-2 ml-md-4" >
                                    <img class="align-middle"  alt="View details"  width="35px"  src="@/assets/icons/question-circle.svg" style="cursor: pointer;"  />
                                </a>
                            </p>
                        </div>
                        <div class="col-sm-3 col-8 mt-sm-0 mt-3 ">
                            <b-button variant="primary" style="width:100%" @click="onPartnersCsvUpload"  :disabled="!partnersCsvFile || partnersCsvFileImportInProgress">                        
                            <b-spinner small :class="this.partnersCsvFileImportInProgress ? 'mr-2' : 'd-none'"></b-spinner>
                            <span class="font-weight-bold text-uppercase font-size-14">{{ $t('buttons.save') }} {{partnersCsvFile ? '['+ this.partnersCsvFile.name + ']' : ''}}</span>
                            </b-button>
                        </div>
                    </div>

                    <div v-if="itemsCsvFailures" class="row">
                        <div class="col-12 pt-4">
                            <div class="font-weight-bold text-danger font-size-14">Erreurs d'imports : 
                                <div class="text-dark font-weight-normal font-size-14 " v-for="(failure, index) in itemsCsvFailures" :key="index">{{ failure }}</div>
                            </div>
                        </div>
                    </div>
            </div>


      </div>
  
         
  </template>
  

  <style scoped>
  .custom-border {
    border: 1px dashed #cccccc;
    border-radius: 4px;
    padding: 16px;
    }

    
  
    
  </style>
